/* unplugin-vue-components disabled */import script from "./UploadedImagesGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadedImagesGrid.vue?vue&type=script&setup=true&lang=js"

import "./UploadedImagesGrid.vue?vue&type=style&index=0&id=f4d087a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f4d087a6"]])

export default __exports__